import { useEffect, RefObject } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Hook that animates card opacity based on viewport position.
 * - Card in top 10% of screen: opacity 0.4
 * - Card in middle (10-75%): opacity 1
 * - Card in bottom 25% of screen: opacity 0.4
 */
export const useCardsOpacityAnimation = (
  cardsContainerRef: RefObject<HTMLDivElement | null>
) => {
  useEffect(() => {
    const container = cardsContainerRef.current;
    if (!container) return;

    const triggers: ScrollTrigger[] = [];
    const cards = container.children;

    Array.from(cards).forEach((card) => {
      gsap.set(card, { opacity: 0.4 });

      // Bottom trigger: entering from bottom (75% from top)
      const bottomTrigger = ScrollTrigger.create({
        trigger: card,
        start: "center 75%",
        end: "center 15%",
        onEnter: () => {
          gsap.to(card, { opacity: 1, duration: 0.3, ease: "power2.out" });
        },
        onLeaveBack: () => {
          gsap.to(card, { opacity: 0.4, duration: 0.1, ease: "power2.out" });
        },
        onLeave: () => {
          gsap.to(card, { opacity: 0.4, duration: 0.1, ease: "power2.out" });
        },
        onEnterBack: () => {
          gsap.to(card, { opacity: 1, duration: 0.3, ease: "power2.out" });
        },
      });

      triggers.push(bottomTrigger);
    });

    return () => {
      triggers.forEach((trigger) => trigger.kill());
    };
  }, [cardsContainerRef]);
};
